<template>
    <div class="pa-5 ma-3 white rounded-lg">
        <div class="subheading grey--text mb-9">Payments</div>

        <v-row>
            <v-col cols="6" offset="6" class="pt-0">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Filter" single-line hide-details @keypress.enter="onSearch"></v-text-field>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="items" :footer-props="paginationOptions" :search="search"
            item-key="id" :options="pagination" :loading="loading" @pagination="onPagination">
            <template v-slot:item.paymentDate="{ item }">
                {{ formatDate( item.paymentDate ) }}
            </template>
            <template v-slot:item.paymentAmount="{ item }">
                {{ formatMoney( item.paymentAmount ) }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-menu rounded left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-on="on" v-bind="attrs">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item @click="maybeEditPayment( item )">
                            <v-list-item-icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Edit</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="maybeDeletePayment( item )">
                            <v-list-item-icon>
                                <v-icon>mdi-delete</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Delete</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-menu>
                
            </template>
        </v-data-table>

        <v-dialog v-model="warningDialog" width="400">
            <v-card>
                <v-card-title>Warning</v-card-title>
                <v-card-text>Are you sure you want to delete this paymet?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="warningDialog = false">Cancel</v-btn>
                    <v-btn depressed color="error" :loading="processing" @click="confirmDelete">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="editDialog" width="600">
            <v-card>
                <v-card-title>Edit Payment</v-card-title>
                <v-card-text class="pt-2">
                    <v-row v-if="selectedPayment != null">
                        <v-col cols="6" class="py-1">Order Num</v-col>
                        <v-col cols="6" class="py-1 font-weight-bold">{{ selectedPayment.orderNum }}</v-col>

                        <v-col cols="6" class="py-1">Date</v-col>
                        <v-col cols="6" class="py-1">{{ formatDate( selectedPayment.paymentDate ) }}</v-col>

                        <v-col cols="6" class="py-1">Method</v-col>
                        <v-col cols="6" class="py-1">{{ selectedPayment.paymentMethod }}</v-col>

                        <v-col cols="6" class="py-1">Amount</v-col>
                        <v-col cols="6" class="py-1">
                            <v-text-field v-model="selectedPayment.paymentAmount" hide-details outlined dense></v-text-field>
                        </v-col>

                        <v-col cols="6" class="py-1">Confirmation number</v-col>
                        <v-col cols="6" class="py-1">
                            <v-text-field v-model="selectedPayment.confirmationNumber" hide-details outlined dense></v-text-field>
                        </v-col>

                        <v-col cols="6" class="py-1">Memo</v-col>
                        <v-col cols="6" class="py-1">
                            <v-text-field v-model="selectedPayment.memo" hide-details outlined dense></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey darken-1" text @click="editDialog = false">Cancel</v-btn>
                    <v-btn depressed color="grey darken-4" class="white--text" :loading="processing" @click="savePayment">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { bus } from '@/main';

export default {
    data: () => ({
        headers             : [
            { text: 'ID', value: 'id', sortable: false },
            { text: 'Order #', value: 'orderNum', sortable: true },
            { text: 'Date', value: 'paymentDate', sortable: true },
            { text: 'Method', value: 'paymentMethod', sortable: true },
            { text: 'Amount', value: 'paymentAmount', sortable: true },
            { text: 'Confirmation', value: 'confirmationNumber', sortable: true },
            { text: 'Memo', value: 'memo', sortable: false },
            { text: 'Actions', value: 'actions', sortable: false , align: 'right' }
            
        ],
        pagination          : {
            sortBy: ['orderDate']
        },
        paginationOptions   : { itemsPerPageOptions: [ 25, 50, -1 ] },
        loading             : false,
        processing          : false,
        search              : '',

        warningDialog       : false,
        editDialog          : false,
        selectedPayment     : null,
    }),
    computed: {
        ...mapGetters({
            items       : 'payments/payments',
            hasMore     : 'payments/hasMore'
        }),
    },
    mounted() {
        this.init();
    },
    methods: {
        ...mapActions({
            loadPayments    : 'payments/loadPayments',
            findPayments    : 'payments/findPayments',
            deletePayment   : 'payments/deletePayment',
            updatePayment   : 'payments/updatePayment'
        }),
        async init() {
            try {
                this.loading = true;
                await this.loadPayments( this.search );
            }
            catch( error ) {
                console.error( error );
            }
            finally {
                this.loading = false;
            }
        },
        formatDate(d) {
            return moment(d).format('YYYY-MM-DD');
        },
        onPagination(v) {
            if( v.pageCount != v.page || this.search != '' ) {
                return;
            }

            this.loadMore( this.search );
        },
        async onSearch() {
            try {
                this.loading = true;
                await this.findPayments( this.search );
            }
            catch( error ) {
                console.error( error );
            }
            finally {
                this.loading = false;
            }
        },
        async loadMore() {
            try {
                if( !this.hasMore )
                    return;
                
                this.loading = true;
                await this.loadPayments( this.search );
            }
            catch(error) {
                console.error( error );
            }
            finally {
                this.loading = false;
            }
        },
        maybeEditPayment( payment ) {
            this.selectedPayment = payment;
            this.editDialog = true;
        },
        maybeDeletePayment( payment ) {
            this.selectedPayment = payment;
            this.warningDialog = true;
        },
        async savePayment() {
            if( this.selectedPayment == null )
                return;
            
            try {
                this.processing = true;
                await this.updatePayment( this.selectedPayment );
                this.editDialog = false;
                this.selectedPayment = null;

                bus.$emit('alert', { 
                    text: 'Payment updated successfully', 
                    color: 'success',
                });
            }
            catch( error ) {
                console.error( error );
            }
            finally {
                this.processing = false;
            }
        },
        async confirmDelete() {
            if( this.selectedPayment == null )
                return;

            try {
                this.processing = true;
                await this.deletePayment( this.selectedPayment.id );
                this.warningDialog = false;
                this.selectedPayment = null;

                bus.$emit('alert', { 
                    text: 'Payment deleted successfully', 
                    color: 'success',
                });
            }
            catch( error ) {
                console.error( error );
            }
            finally {
                this.processing = false;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>